const searchAndFilterModule = {
  id: "",
  config: {
    general: {
      corners: {
        label: "Round",
        value: "round",
      },
      accentColor: {
        label: "Custom 1",
        value: "#2F79FF",
      },
      pageBackgroundColor: {
        label: "Default White",
        value: "#fff",
      },
      theme: {
        label: "Dark",
        value: "default-light",
      },
      paddings: {
        top: true,
        bottom: true,
      },
    },
    filters: {
      options: [
        {
          key: "company",
          label: "Unternehmen",
          visibleOnCards: true,
          type: "list",
          active: true,
          preset: [],
        },
        {
          key: "department",
          label: "Bereich",
          visibleOnCards: true,
          type: "list",
          active: true,
          preset: ["Engineering"],
        },
        {
          key: "location",
          label: "Einsatzort",
          visibleOnCards: true,
          type: "location",
          active: true,
          preset: [],
        },
        {
          key: "schedule",
          label: "Arbeitszeit",
          visibleOnCards: false,
          type: "select",
          active: true,
          preset: ["Full-time"],
        },
        {
          key: "start_year",
          label: "Startjahr",
          visibleOnCards: false,
          type: "select",
          active: false,
          preset: [],
        },
        {
          key: "career_level",
          label: "Karrierelevel",
          visibleOnCards: false,
          type: "list",
          active: false,
          preset: [],
        },
        {
          key: "working_hours",
          label: "Wochenarbeitszeit",
          visibleOnCards: false,
          type: "list",
          active: false,
          preset: [],
        },
        {
          key: "work_mode",
          label: "Arbeitsmodus",
          visibleOnCards: false,
          type: "select",
          active: false,
          preset: [],
        },
      ],
      resetButtonsText: {
        singleFilter: "Filter löschen",
        allFilters: "Alle Filter löschen",
      },
      emptyStateText: "Keine Filter gefunden. Bitte versuche es noch einmal.",
      placeholderText: "Suchen",
      backToResultsText: "zurück zu den Suchergebnissen",
      nationwideText: "nationwide",
    },
    search: {
      placeholderText: "Suche nach Jobtitel",
      active: false,
      preset: "Assistant",
    },
    results: {
      amountHitsText: "Jobs",
      emptyState: {
        headline: "Keine passenden Jobs gefunden.",
        subline:
          "Es wurden keine Jobangebote gefunden. Filter oder Suchbegriffe können angepasst werden, um bessere Ergebnisse zu erzielen.",
      },
      pagination: {
        firstText: "Erste Seite",
        previousText: "Vorherige Seite",
        nextText: "Nächste Seite",
        lastText: "Letzte Seite",
      },
    },
    map: {
      showMap: true,
      mapStyle: {
        label: "Light",
        value: "light", // light, dark, white, grayscale, black
      },
      markerColor: {
        label: "Blue",
        value: "#489CDC",
      },
    },
  },
};

export default searchAndFilterModule;
